import { gql } from '@apollo/client';

export const CREATE_ORGANISATION = gql`
  mutation createOrganisation($orgSchema: OrganisationCreateSchema!) {
    createOrganisation(orgSchema: $orgSchema) {
      name
    }
  }
`;

export const UPDATE_ORGANISATION = gql`
  mutation updateOrganisation(
    $uuid: String!
    $orgSchema: OrganisationUpdateSchema!
  ) {
    updateOrganisation(uuid: $uuid, orgSchema: $orgSchema) {
      name
    }
  }
`;

export const DELETE_USER_MEMBERSHIP = gql`
  mutation deleteMembership($id: ID!, $organisation: String!) {
    deleteMembership(input: { id: $id, organisation: $organisation })
  }
`;

export const DEACTIVATE_MEMBERSHIP = gql`
  mutation disableMembership($id: ID!, $organisation: String!) {
    disableMembership(input: { id: $id, organisation: $organisation })
  }
`;

export const ACTIVATE_MEMBERSHIP = gql`
  mutation enableMembership($id: ID!, $organisation: String!) {
    enableMembership(input: { id: $id, organisation: $organisation })
  }
`;

export const DISABLE_USER = gql`
  mutation disableUser($id: ID!) {
    disableUser(input: { id: $id })
  }
`;

export const TOGGLE_USER = gql`
  mutation toggleUser($id: String!, $status: Boolean!) {
    toggleUser(id: $id, status: $status)
  }
`;

export const ENABLE_USER = gql`
  mutation enableUser($id: ID!) {
    enableUser(input: { id: $id })
  }
`;

export const RESET_MFA = gql`
  mutation resetUserMfa($userIds: [ID!]!) {
    resetUserMfa(userIds: $userIds) {
      passed
      errors {
        uniqueIdentifier
        message
      }
    }
  }
`;
